export const OTROS = { ID: 1, CODIGO: '0' };
export const DNI = { ID: 2, CODIGO: '1' };
export const CARNET_EXTRANJERIA = { ID: 3, CODIGO: '4' };
export const RUC = { ID: 4, CODIGO: '6' };
export const PASAPORTE = { ID: 5, CODIGO: '7' };
export const PLACA = { ID: 6, CODIGO: 'A' };